import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    '快速链接': [
      { label: '首页', href: '#hero' },
      { label: '服务项目', href: '#services' },
      { label: '关于我们', href: '#about' },
      { label: '团队介绍', href: '#team' },
    ],
    '服务内容': [
      { label: '心灵游乐场', href: '#services' },
      { label: '艺术心理教育联盟', href: '#services' },
      { label: '少年未来岛', href: '#services' },
      { label: 'LOMILOLA品牌系列', href: '#services' },
    ],
    '联系方式': [
      { label: '电话咨询', href: '#contact' },
      { label: '在线预约', href: '#contact' },
      { label: '企业合作', href: '#contact' },
      { label: '加入我们', href: '#contact' },
    ],
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-about">
            <h3 className="footer-title">深圳市高帝思教育咨询有限公司</h3>
            <p className="footer-description">
              致力于艺术心理教育在学校教育、家庭教育和专业人才培养领域的推广与应用。
              让推动摇篮的手推动世界，提升全民心灵幸福指数。
            </p>
            <div className="footer-social">
              <a href="#contact" onClick={(e) => handleLinkClick(e, '#contact')} className="footer-social-link" aria-label="微信">微信</a>
              <a href="#contact" onClick={(e) => handleLinkClick(e, '#contact')} className="footer-social-link" aria-label="微博">微博</a>
              <a href="#contact" onClick={(e) => handleLinkClick(e, '#contact')} className="footer-social-link" aria-label="抖音">抖音</a>
              <a href="#contact" onClick={(e) => handleLinkClick(e, '#contact')} className="footer-social-link" aria-label="小红书">小红书</a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category} className="footer-section">
              <h4 className="footer-section-title">{category}</h4>
              <ul className="footer-links">
                {links.map((link) => (
                  <li key={link.label} className="footer-link-item">
                    <a
                      href={link.href}
                      onClick={(e) => handleLinkClick(e, link.href)}
                      className="footer-link"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} 深圳市高帝思教育咨询有限公司 版权所有
          </p>
          <p className="footer-tagline">
            让推动摇篮的手推动世界
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
